import styled, { css, keyframes } from 'styled-components';
import {
  CONTENT_ANIMATION_DURATION,
  DEFAULT_TYPING_ANIMATION_DURATION,
} from 'components/TypingIndicator/constants';

const getDelayFromFirstMessage = (index: number) => {
  // NOTE: very important. Can't set as 0 since initial "single" animation bubble
  //       must load first. Without minimum keyframe, messages won't always render correctly.
  if (index === 0) return CONTENT_ANIMATION_DURATION;

  // decrement one position backwards since first message has its own delay.
  return (index - 1) * DEFAULT_TYPING_ANIMATION_DURATION;
};

const MessageDelayKeyframes = keyframes`
0% { 
  opacity: 0;
  transform: scaleY(0); 
  height: 0; 
  overflow:hidden;
}

60% {
  opacity: 0; 
  transform: scaleY(0);
  height: 0; 
  overflow:hidden;
}

100% {
  opacity:1;
  transform-origin:top;
  transform: scaleY(1);
  height: initial;
  overflow:initial;
}`;

const AnimationMixin = css<{ index: number }>`
  ${MessageDelayKeyframes} ${({ index }) => getDelayFromFirstMessage(index)}ms
`;

export const DelayAnimation = styled.div<{ index: number; animate: boolean }>`
  animation: ${({ animate }) => (animate ? AnimationMixin : undefined)};
`;
